/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as TeamDefs from '../team/defs.defs.js'
import * as ModerationDefs from '../moderation/defs.defs.js'
import * as ModerationDefs$$0 from '../../../com/atproto/moderation/defs.defs.js'
import * as QueueDefs from '../queue/defs.defs.js'

const $nsid = 'tools.ozone.report.defs'

type $nsid = typeof $nsid

export { $nsid }

type ReasonType =
  | 'tools.ozone.report.defs#reasonAppeal'
  | 'tools.ozone.report.defs#reasonOther'
  | 'tools.ozone.report.defs#reasonViolenceAnimal'
  | 'tools.ozone.report.defs#reasonViolenceThreats'
  | 'tools.ozone.report.defs#reasonViolenceGraphicContent'
  | 'tools.ozone.report.defs#reasonViolenceGlorification'
  | 'tools.ozone.report.defs#reasonViolenceExtremistContent'
  | 'tools.ozone.report.defs#reasonViolenceTrafficking'
  | 'tools.ozone.report.defs#reasonViolenceOther'
  | 'tools.ozone.report.defs#reasonSexualAbuseContent'
  | 'tools.ozone.report.defs#reasonSexualNCII'
  | 'tools.ozone.report.defs#reasonSexualDeepfake'
  | 'tools.ozone.report.defs#reasonSexualAnimal'
  | 'tools.ozone.report.defs#reasonSexualUnlabeled'
  | 'tools.ozone.report.defs#reasonSexualOther'
  | 'tools.ozone.report.defs#reasonChildSafetyCSAM'
  | 'tools.ozone.report.defs#reasonChildSafetyGroom'
  | 'tools.ozone.report.defs#reasonChildSafetyPrivacy'
  | 'tools.ozone.report.defs#reasonChildSafetyHarassment'
  | 'tools.ozone.report.defs#reasonChildSafetyOther'
  | 'tools.ozone.report.defs#reasonHarassmentTroll'
  | 'tools.ozone.report.defs#reasonHarassmentTargeted'
  | 'tools.ozone.report.defs#reasonHarassmentHateSpeech'
  | 'tools.ozone.report.defs#reasonHarassmentDoxxing'
  | 'tools.ozone.report.defs#reasonHarassmentOther'
  | 'tools.ozone.report.defs#reasonMisleadingBot'
  | 'tools.ozone.report.defs#reasonMisleadingImpersonation'
  | 'tools.ozone.report.defs#reasonMisleadingSpam'
  | 'tools.ozone.report.defs#reasonMisleadingScam'
  | 'tools.ozone.report.defs#reasonMisleadingElections'
  | 'tools.ozone.report.defs#reasonMisleadingOther'
  | 'tools.ozone.report.defs#reasonRuleSiteSecurity'
  | 'tools.ozone.report.defs#reasonRuleProhibitedSales'
  | 'tools.ozone.report.defs#reasonRuleBanEvasion'
  | 'tools.ozone.report.defs#reasonRuleOther'
  | 'tools.ozone.report.defs#reasonSelfHarmContent'
  | 'tools.ozone.report.defs#reasonSelfHarmED'
  | 'tools.ozone.report.defs#reasonSelfHarmStunts'
  | 'tools.ozone.report.defs#reasonSelfHarmSubstances'
  | 'tools.ozone.report.defs#reasonSelfHarmOther'
  | l.UnknownString

export type { ReasonType }

const reasonType = /*#__PURE__*/ l.string<{
  knownValues: [
    'tools.ozone.report.defs#reasonAppeal',
    'tools.ozone.report.defs#reasonOther',
    'tools.ozone.report.defs#reasonViolenceAnimal',
    'tools.ozone.report.defs#reasonViolenceThreats',
    'tools.ozone.report.defs#reasonViolenceGraphicContent',
    'tools.ozone.report.defs#reasonViolenceGlorification',
    'tools.ozone.report.defs#reasonViolenceExtremistContent',
    'tools.ozone.report.defs#reasonViolenceTrafficking',
    'tools.ozone.report.defs#reasonViolenceOther',
    'tools.ozone.report.defs#reasonSexualAbuseContent',
    'tools.ozone.report.defs#reasonSexualNCII',
    'tools.ozone.report.defs#reasonSexualDeepfake',
    'tools.ozone.report.defs#reasonSexualAnimal',
    'tools.ozone.report.defs#reasonSexualUnlabeled',
    'tools.ozone.report.defs#reasonSexualOther',
    'tools.ozone.report.defs#reasonChildSafetyCSAM',
    'tools.ozone.report.defs#reasonChildSafetyGroom',
    'tools.ozone.report.defs#reasonChildSafetyPrivacy',
    'tools.ozone.report.defs#reasonChildSafetyHarassment',
    'tools.ozone.report.defs#reasonChildSafetyOther',
    'tools.ozone.report.defs#reasonHarassmentTroll',
    'tools.ozone.report.defs#reasonHarassmentTargeted',
    'tools.ozone.report.defs#reasonHarassmentHateSpeech',
    'tools.ozone.report.defs#reasonHarassmentDoxxing',
    'tools.ozone.report.defs#reasonHarassmentOther',
    'tools.ozone.report.defs#reasonMisleadingBot',
    'tools.ozone.report.defs#reasonMisleadingImpersonation',
    'tools.ozone.report.defs#reasonMisleadingSpam',
    'tools.ozone.report.defs#reasonMisleadingScam',
    'tools.ozone.report.defs#reasonMisleadingElections',
    'tools.ozone.report.defs#reasonMisleadingOther',
    'tools.ozone.report.defs#reasonRuleSiteSecurity',
    'tools.ozone.report.defs#reasonRuleProhibitedSales',
    'tools.ozone.report.defs#reasonRuleBanEvasion',
    'tools.ozone.report.defs#reasonRuleOther',
    'tools.ozone.report.defs#reasonSelfHarmContent',
    'tools.ozone.report.defs#reasonSelfHarmED',
    'tools.ozone.report.defs#reasonSelfHarmStunts',
    'tools.ozone.report.defs#reasonSelfHarmSubstances',
    'tools.ozone.report.defs#reasonSelfHarmOther',
  ]
}>()

export { reasonType }

/** Appeal a previously taken moderation action */
const reasonAppeal = /*#__PURE__*/ l.token($nsid, 'reasonAppeal')

export { reasonAppeal }

/** Appeal a previously taken moderation action */
const ReasonAppeal = /*#__PURE__*/ reasonAppeal.value

/** Appeal a previously taken moderation action */
type ReasonAppeal = typeof ReasonAppeal

export { ReasonAppeal }

/** An issue not included in these options */
const reasonOther = /*#__PURE__*/ l.token($nsid, 'reasonOther')

export { reasonOther }

/** An issue not included in these options */
const ReasonOther = /*#__PURE__*/ reasonOther.value

/** An issue not included in these options */
type ReasonOther = typeof ReasonOther

export { ReasonOther }

/** Animal welfare violations */
const reasonViolenceAnimal = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceAnimal',
)

export { reasonViolenceAnimal }

/** Animal welfare violations */
const ReasonViolenceAnimal = /*#__PURE__*/ reasonViolenceAnimal.value

/** Animal welfare violations */
type ReasonViolenceAnimal = typeof ReasonViolenceAnimal

export { ReasonViolenceAnimal }

/** Threats or incitement */
const reasonViolenceThreats = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceThreats',
)

export { reasonViolenceThreats }

/** Threats or incitement */
const ReasonViolenceThreats = /*#__PURE__*/ reasonViolenceThreats.value

/** Threats or incitement */
type ReasonViolenceThreats = typeof ReasonViolenceThreats

export { ReasonViolenceThreats }

/** Graphic violent content */
const reasonViolenceGraphicContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceGraphicContent',
)

export { reasonViolenceGraphicContent }

/** Graphic violent content */
const ReasonViolenceGraphicContent =
  /*#__PURE__*/ reasonViolenceGraphicContent.value

/** Graphic violent content */
type ReasonViolenceGraphicContent = typeof ReasonViolenceGraphicContent

export { ReasonViolenceGraphicContent }

/** Glorification of violence */
const reasonViolenceGlorification = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceGlorification',
)

export { reasonViolenceGlorification }

/** Glorification of violence */
const ReasonViolenceGlorification =
  /*#__PURE__*/ reasonViolenceGlorification.value

/** Glorification of violence */
type ReasonViolenceGlorification = typeof ReasonViolenceGlorification

export { ReasonViolenceGlorification }

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonViolenceExtremistContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceExtremistContent',
)

export { reasonViolenceExtremistContent }

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
const ReasonViolenceExtremistContent =
  /*#__PURE__*/ reasonViolenceExtremistContent.value

/** Extremist content. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonViolenceExtremistContent = typeof ReasonViolenceExtremistContent

export { ReasonViolenceExtremistContent }

/** Human trafficking */
const reasonViolenceTrafficking = /*#__PURE__*/ l.token(
  $nsid,
  'reasonViolenceTrafficking',
)

export { reasonViolenceTrafficking }

/** Human trafficking */
const ReasonViolenceTrafficking = /*#__PURE__*/ reasonViolenceTrafficking.value

/** Human trafficking */
type ReasonViolenceTrafficking = typeof ReasonViolenceTrafficking

export { ReasonViolenceTrafficking }

/** Other violent content */
const reasonViolenceOther = /*#__PURE__*/ l.token($nsid, 'reasonViolenceOther')

export { reasonViolenceOther }

/** Other violent content */
const ReasonViolenceOther = /*#__PURE__*/ reasonViolenceOther.value

/** Other violent content */
type ReasonViolenceOther = typeof ReasonViolenceOther

export { ReasonViolenceOther }

/** Adult sexual abuse content */
const reasonSexualAbuseContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualAbuseContent',
)

export { reasonSexualAbuseContent }

/** Adult sexual abuse content */
const ReasonSexualAbuseContent = /*#__PURE__*/ reasonSexualAbuseContent.value

/** Adult sexual abuse content */
type ReasonSexualAbuseContent = typeof ReasonSexualAbuseContent

export { ReasonSexualAbuseContent }

/** Non-consensual intimate imagery */
const reasonSexualNCII = /*#__PURE__*/ l.token($nsid, 'reasonSexualNCII')

export { reasonSexualNCII }

/** Non-consensual intimate imagery */
const ReasonSexualNcii = /*#__PURE__*/ reasonSexualNCII.value

/** Non-consensual intimate imagery */
type ReasonSexualNcii = typeof ReasonSexualNcii

export { ReasonSexualNcii }

/** Deepfake adult content */
const reasonSexualDeepfake = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualDeepfake',
)

export { reasonSexualDeepfake }

/** Deepfake adult content */
const ReasonSexualDeepfake = /*#__PURE__*/ reasonSexualDeepfake.value

/** Deepfake adult content */
type ReasonSexualDeepfake = typeof ReasonSexualDeepfake

export { ReasonSexualDeepfake }

/** Animal sexual abuse */
const reasonSexualAnimal = /*#__PURE__*/ l.token($nsid, 'reasonSexualAnimal')

export { reasonSexualAnimal }

/** Animal sexual abuse */
const ReasonSexualAnimal = /*#__PURE__*/ reasonSexualAnimal.value

/** Animal sexual abuse */
type ReasonSexualAnimal = typeof ReasonSexualAnimal

export { ReasonSexualAnimal }

/** Unlabelled adult content */
const reasonSexualUnlabeled = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSexualUnlabeled',
)

export { reasonSexualUnlabeled }

/** Unlabelled adult content */
const ReasonSexualUnlabeled = /*#__PURE__*/ reasonSexualUnlabeled.value

/** Unlabelled adult content */
type ReasonSexualUnlabeled = typeof ReasonSexualUnlabeled

export { ReasonSexualUnlabeled }

/** Other sexual violence content */
const reasonSexualOther = /*#__PURE__*/ l.token($nsid, 'reasonSexualOther')

export { reasonSexualOther }

/** Other sexual violence content */
const ReasonSexualOther = /*#__PURE__*/ reasonSexualOther.value

/** Other sexual violence content */
type ReasonSexualOther = typeof ReasonSexualOther

export { ReasonSexualOther }

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyCSAM = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyCSAM',
)

export { reasonChildSafetyCSAM }

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
const ReasonChildSafetyCsam = /*#__PURE__*/ reasonChildSafetyCSAM.value

/** Child sexual abuse material (CSAM). These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyCsam = typeof ReasonChildSafetyCsam

export { ReasonChildSafetyCsam }

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyGroom = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyGroom',
)

export { reasonChildSafetyGroom }

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
const ReasonChildSafetyGroom = /*#__PURE__*/ reasonChildSafetyGroom.value

/** Grooming or predatory behavior. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyGroom = typeof ReasonChildSafetyGroom

export { ReasonChildSafetyGroom }

/** Privacy violation involving a minor */
const reasonChildSafetyPrivacy = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyPrivacy',
)

export { reasonChildSafetyPrivacy }

/** Privacy violation involving a minor */
const ReasonChildSafetyPrivacy = /*#__PURE__*/ reasonChildSafetyPrivacy.value

/** Privacy violation involving a minor */
type ReasonChildSafetyPrivacy = typeof ReasonChildSafetyPrivacy

export { ReasonChildSafetyPrivacy }

/** Harassment or bullying of minors */
const reasonChildSafetyHarassment = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyHarassment',
)

export { reasonChildSafetyHarassment }

/** Harassment or bullying of minors */
const ReasonChildSafetyHarassment =
  /*#__PURE__*/ reasonChildSafetyHarassment.value

/** Harassment or bullying of minors */
type ReasonChildSafetyHarassment = typeof ReasonChildSafetyHarassment

export { ReasonChildSafetyHarassment }

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
const reasonChildSafetyOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonChildSafetyOther',
)

export { reasonChildSafetyOther }

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
const ReasonChildSafetyOther = /*#__PURE__*/ reasonChildSafetyOther.value

/** Other child safety. These reports will be sent only be sent to the application's Moderation Authority. */
type ReasonChildSafetyOther = typeof ReasonChildSafetyOther

export { ReasonChildSafetyOther }

/** Trolling */
const reasonHarassmentTroll = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentTroll',
)

export { reasonHarassmentTroll }

/** Trolling */
const ReasonHarassmentTroll = /*#__PURE__*/ reasonHarassmentTroll.value

/** Trolling */
type ReasonHarassmentTroll = typeof ReasonHarassmentTroll

export { ReasonHarassmentTroll }

/** Targeted harassment */
const reasonHarassmentTargeted = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentTargeted',
)

export { reasonHarassmentTargeted }

/** Targeted harassment */
const ReasonHarassmentTargeted = /*#__PURE__*/ reasonHarassmentTargeted.value

/** Targeted harassment */
type ReasonHarassmentTargeted = typeof ReasonHarassmentTargeted

export { ReasonHarassmentTargeted }

/** Hate speech */
const reasonHarassmentHateSpeech = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentHateSpeech',
)

export { reasonHarassmentHateSpeech }

/** Hate speech */
const ReasonHarassmentHateSpeech =
  /*#__PURE__*/ reasonHarassmentHateSpeech.value

/** Hate speech */
type ReasonHarassmentHateSpeech = typeof ReasonHarassmentHateSpeech

export { ReasonHarassmentHateSpeech }

/** Doxxing */
const reasonHarassmentDoxxing = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentDoxxing',
)

export { reasonHarassmentDoxxing }

/** Doxxing */
const ReasonHarassmentDoxxing = /*#__PURE__*/ reasonHarassmentDoxxing.value

/** Doxxing */
type ReasonHarassmentDoxxing = typeof ReasonHarassmentDoxxing

export { ReasonHarassmentDoxxing }

/** Other harassing or hateful content */
const reasonHarassmentOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonHarassmentOther',
)

export { reasonHarassmentOther }

/** Other harassing or hateful content */
const ReasonHarassmentOther = /*#__PURE__*/ reasonHarassmentOther.value

/** Other harassing or hateful content */
type ReasonHarassmentOther = typeof ReasonHarassmentOther

export { ReasonHarassmentOther }

/** Fake account or bot */
const reasonMisleadingBot = /*#__PURE__*/ l.token($nsid, 'reasonMisleadingBot')

export { reasonMisleadingBot }

/** Fake account or bot */
const ReasonMisleadingBot = /*#__PURE__*/ reasonMisleadingBot.value

/** Fake account or bot */
type ReasonMisleadingBot = typeof ReasonMisleadingBot

export { ReasonMisleadingBot }

/** Impersonation */
const reasonMisleadingImpersonation = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingImpersonation',
)

export { reasonMisleadingImpersonation }

/** Impersonation */
const ReasonMisleadingImpersonation =
  /*#__PURE__*/ reasonMisleadingImpersonation.value

/** Impersonation */
type ReasonMisleadingImpersonation = typeof ReasonMisleadingImpersonation

export { ReasonMisleadingImpersonation }

/** Spam */
const reasonMisleadingSpam = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingSpam',
)

export { reasonMisleadingSpam }

/** Spam */
const ReasonMisleadingSpam = /*#__PURE__*/ reasonMisleadingSpam.value

/** Spam */
type ReasonMisleadingSpam = typeof ReasonMisleadingSpam

export { ReasonMisleadingSpam }

/** Scam */
const reasonMisleadingScam = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingScam',
)

export { reasonMisleadingScam }

/** Scam */
const ReasonMisleadingScam = /*#__PURE__*/ reasonMisleadingScam.value

/** Scam */
type ReasonMisleadingScam = typeof ReasonMisleadingScam

export { ReasonMisleadingScam }

/** False information about elections */
const reasonMisleadingElections = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingElections',
)

export { reasonMisleadingElections }

/** False information about elections */
const ReasonMisleadingElections = /*#__PURE__*/ reasonMisleadingElections.value

/** False information about elections */
type ReasonMisleadingElections = typeof ReasonMisleadingElections

export { ReasonMisleadingElections }

/** Other misleading content */
const reasonMisleadingOther = /*#__PURE__*/ l.token(
  $nsid,
  'reasonMisleadingOther',
)

export { reasonMisleadingOther }

/** Other misleading content */
const ReasonMisleadingOther = /*#__PURE__*/ reasonMisleadingOther.value

/** Other misleading content */
type ReasonMisleadingOther = typeof ReasonMisleadingOther

export { ReasonMisleadingOther }

/** Hacking or system attacks */
const reasonRuleSiteSecurity = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleSiteSecurity',
)

export { reasonRuleSiteSecurity }

/** Hacking or system attacks */
const ReasonRuleSiteSecurity = /*#__PURE__*/ reasonRuleSiteSecurity.value

/** Hacking or system attacks */
type ReasonRuleSiteSecurity = typeof ReasonRuleSiteSecurity

export { ReasonRuleSiteSecurity }

/** Promoting or selling prohibited items or services */
const reasonRuleProhibitedSales = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleProhibitedSales',
)

export { reasonRuleProhibitedSales }

/** Promoting or selling prohibited items or services */
const ReasonRuleProhibitedSales = /*#__PURE__*/ reasonRuleProhibitedSales.value

/** Promoting or selling prohibited items or services */
type ReasonRuleProhibitedSales = typeof ReasonRuleProhibitedSales

export { ReasonRuleProhibitedSales }

/** Banned user returning */
const reasonRuleBanEvasion = /*#__PURE__*/ l.token(
  $nsid,
  'reasonRuleBanEvasion',
)

export { reasonRuleBanEvasion }

/** Banned user returning */
const ReasonRuleBanEvasion = /*#__PURE__*/ reasonRuleBanEvasion.value

/** Banned user returning */
type ReasonRuleBanEvasion = typeof ReasonRuleBanEvasion

export { ReasonRuleBanEvasion }

/** Other */
const reasonRuleOther = /*#__PURE__*/ l.token($nsid, 'reasonRuleOther')

export { reasonRuleOther }

/** Other */
const ReasonRuleOther = /*#__PURE__*/ reasonRuleOther.value

/** Other */
type ReasonRuleOther = typeof ReasonRuleOther

export { ReasonRuleOther }

/** Content promoting or depicting self-harm */
const reasonSelfHarmContent = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmContent',
)

export { reasonSelfHarmContent }

/** Content promoting or depicting self-harm */
const ReasonSelfHarmContent = /*#__PURE__*/ reasonSelfHarmContent.value

/** Content promoting or depicting self-harm */
type ReasonSelfHarmContent = typeof ReasonSelfHarmContent

export { ReasonSelfHarmContent }

/** Eating disorders */
const reasonSelfHarmED = /*#__PURE__*/ l.token($nsid, 'reasonSelfHarmED')

export { reasonSelfHarmED }

/** Eating disorders */
const ReasonSelfHarmEd = /*#__PURE__*/ reasonSelfHarmED.value

/** Eating disorders */
type ReasonSelfHarmEd = typeof ReasonSelfHarmEd

export { ReasonSelfHarmEd }

/** Dangerous challenges or activities */
const reasonSelfHarmStunts = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmStunts',
)

export { reasonSelfHarmStunts }

/** Dangerous challenges or activities */
const ReasonSelfHarmStunts = /*#__PURE__*/ reasonSelfHarmStunts.value

/** Dangerous challenges or activities */
type ReasonSelfHarmStunts = typeof ReasonSelfHarmStunts

export { ReasonSelfHarmStunts }

/** Dangerous substances or drug abuse */
const reasonSelfHarmSubstances = /*#__PURE__*/ l.token(
  $nsid,
  'reasonSelfHarmSubstances',
)

export { reasonSelfHarmSubstances }

/** Dangerous substances or drug abuse */
const ReasonSelfHarmSubstances = /*#__PURE__*/ reasonSelfHarmSubstances.value

/** Dangerous substances or drug abuse */
type ReasonSelfHarmSubstances = typeof ReasonSelfHarmSubstances

export { ReasonSelfHarmSubstances }

/** Other dangerous content */
const reasonSelfHarmOther = /*#__PURE__*/ l.token($nsid, 'reasonSelfHarmOther')

export { reasonSelfHarmOther }

/** Other dangerous content */
const ReasonSelfHarmOther = /*#__PURE__*/ reasonSelfHarmOther.value

/** Other dangerous content */
type ReasonSelfHarmOther = typeof ReasonSelfHarmOther

export { ReasonSelfHarmOther }

/** Information about the moderator currently assigned to a report. */
type ReportAssignment = {
  $type?: 'tools.ozone.report.defs#reportAssignment'

  /**
   * DID of the assigned moderator
   */
  did: l.DidString

  /**
   * Full member record of the assigned moderator
   */
  moderator?: TeamDefs.Member

  /**
   * When the report was assigned
   */
  assignedAt: l.DatetimeString
}

export type { ReportAssignment }

/** Information about the moderator currently assigned to a report. */
const reportAssignment = /*#__PURE__*/ l.typedObject<ReportAssignment>(
  $nsid,
  'reportAssignment',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    moderator: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
    ),
    assignedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { reportAssignment }

type ReportView = {
  $type?: 'tools.ozone.report.defs#reportView'

  /**
   * Report ID
   */
  id: number

  /**
   * ID of the moderation event that created this report
   */
  eventId: number

  /**
   * Current status of the report
   */
  status:
    'open' | 'closed' | 'escalated' | 'queued' | 'assigned' | l.UnknownString

  /**
   * The subject that was reported with full details
   */
  subject: ModerationDefs.SubjectView

  /**
   * Type of report
   */
  reportType: ModerationDefs$$0.ReasonType

  /**
   * DID of the user who made the report
   */
  reportedBy: l.DidString

  /**
   * Full subject view of the reporter account
   */
  reporter: ModerationDefs.SubjectView

  /**
   * Comment provided by the reporter
   */
  comment?: string

  /**
   * When the report was created
   */
  createdAt: l.DatetimeString

  /**
   * When the report was last updated
   */
  updatedAt?: l.DatetimeString

  /**
   * When the report was assigned to its current queue
   */
  queuedAt?: l.DatetimeString

  /**
   * Array of moderation event IDs representing actions taken on this report (sorted DESC, most recent first)
   */
  actionEventIds?: number[]

  /**
   * Optional: expanded action events
   */
  actions?: ModerationDefs.ModEventView[]

  /**
   * Note sent to reporter when report was actioned
   */
  actionNote?: string

  /**
   * Current status of the reported subject
   */
  subjectStatus?: ModerationDefs.SubjectStatusView

  /**
   * Number of other pending reports on the same subject
   */
  relatedReportCount?: number

  /**
   * Information about moderator currently assigned to this report (if any)
   */
  assignment?: ReportAssignment

  /**
   * The queue this report is assigned to (if any)
   */
  queue?: QueueDefs.QueueView

  /**
   * Whether this report is muted. A report is muted if the reporter was muted or the subject was muted at the time the report was created.
   */
  isMuted?: boolean

  /**
   * Whether this report was emitted by automated tooling.
   */
  isAutomated?: boolean
}

export type { ReportView }

const reportView = /*#__PURE__*/ l.typedObject<ReportView>(
  $nsid,
  'reportView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    eventId: /*#__PURE__*/ l.integer(),
    status: /*#__PURE__*/ l.string<{
      knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
    }>(),
    subject: /*#__PURE__*/ l.ref<ModerationDefs.SubjectView>(
      (() => ModerationDefs.subjectView) as any,
    ),
    reportType: /*#__PURE__*/ l.ref<ModerationDefs$$0.ReasonType>(
      (() => ModerationDefs$$0.reasonType) as any,
    ),
    reportedBy: /*#__PURE__*/ l.string({ format: 'did' }),
    reporter: /*#__PURE__*/ l.ref<ModerationDefs.SubjectView>(
      (() => ModerationDefs.subjectView) as any,
    ),
    comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    queuedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    actionEventIds: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.integer()),
    ),
    actions: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ModerationDefs.ModEventView>(
          (() => ModerationDefs.modEventView) as any,
        ),
      ),
    ),
    actionNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    subjectStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ModerationDefs.SubjectStatusView>(
        (() => ModerationDefs.subjectStatusView) as any,
      ),
    ),
    relatedReportCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    assignment: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ReportAssignment>((() => reportAssignment) as any),
    ),
    queue: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<QueueDefs.QueueView>(
        (() => QueueDefs.queueView) as any,
      ),
    ),
    isMuted: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    isAutomated: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false),
    ),
  }),
)

export { reportView }

/** Activity recording a report being routed to a queue. */
type QueueActivity = {
  $type?: 'tools.ozone.report.defs#queueActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    'open' | 'closed' | 'escalated' | 'queued' | 'assigned' | l.UnknownString
}

export type { QueueActivity }

/** Activity recording a report being routed to a queue. */
const queueActivity = /*#__PURE__*/ l.typedObject<QueueActivity>(
  $nsid,
  'queueActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { queueActivity }

/** Activity recording a moderator being assigned to a report. */
type AssignmentActivity = {
  $type?: 'tools.ozone.report.defs#assignmentActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    'open' | 'closed' | 'escalated' | 'queued' | 'assigned' | l.UnknownString
}

export type { AssignmentActivity }

/** Activity recording a moderator being assigned to a report. */
const assignmentActivity = /*#__PURE__*/ l.typedObject<AssignmentActivity>(
  $nsid,
  'assignmentActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { assignmentActivity }

/** Activity recording a report being escalated. */
type EscalationActivity = {
  $type?: 'tools.ozone.report.defs#escalationActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    'open' | 'closed' | 'escalated' | 'queued' | 'assigned' | l.UnknownString
}

export type { EscalationActivity }

/** Activity recording a report being escalated. */
const escalationActivity = /*#__PURE__*/ l.typedObject<EscalationActivity>(
  $nsid,
  'escalationActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { escalationActivity }

/** Activity recording a report being closed. */
type CloseActivity = {
  $type?: 'tools.ozone.report.defs#closeActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    'open' | 'closed' | 'escalated' | 'queued' | 'assigned' | l.UnknownString
}

export type { CloseActivity }

/** Activity recording a report being closed. */
const closeActivity = /*#__PURE__*/ l.typedObject<CloseActivity>(
  $nsid,
  'closeActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { closeActivity }

/** Activity recording a closed report being reopened. Only valid when the report is in 'closed' status. */
type ReopenActivity = {
  $type?: 'tools.ozone.report.defs#reopenActivity'

  /**
   * The report's status before this activity. Populated automatically from the report row; not required in input.
   */
  previousStatus?:
    'open' | 'closed' | 'escalated' | 'queued' | 'assigned' | l.UnknownString
}

export type { ReopenActivity }

/** Activity recording a closed report being reopened. Only valid when the report is in 'closed' status. */
const reopenActivity = /*#__PURE__*/ l.typedObject<ReopenActivity>(
  $nsid,
  'reopenActivity',
  /*#__PURE__*/ l.object({
    previousStatus: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string<{
        knownValues: ['open', 'closed', 'escalated', 'queued', 'assigned']
      }>(),
    ),
  }),
)

export { reopenActivity }

/** Activity recording a note on a report. Use internalNote for moderator-only notes or publicNote for reporter-visible notes (or both). */
type NoteActivity = { $type?: 'tools.ozone.report.defs#noteActivity' }

export type { NoteActivity }

/** Activity recording a note on a report. Use internalNote for moderator-only notes or publicNote for reporter-visible notes (or both). */
const noteActivity = /*#__PURE__*/ l.typedObject<NoteActivity>(
  $nsid,
  'noteActivity',
  /*#__PURE__*/ l.object({}),
)

export { noteActivity }

/** A single activity entry on a report. */
type ReportActivityView = {
  $type?: 'tools.ozone.report.defs#reportActivityView'

  /**
   * Activity ID
   */
  id: number

  /**
   * ID of the report this activity belongs to
   */
  reportId: number

  /**
   * The typed activity object describing what occurred.
   */
  activity:
    | l.$Typed<QueueActivity>
    | l.$Typed<AssignmentActivity>
    | l.$Typed<EscalationActivity>
    | l.$Typed<CloseActivity>
    | l.$Typed<ReopenActivity>
    | l.$Typed<NoteActivity>
    | l.Unknown$TypedObject

  /**
   * Optional moderator-only note. Not visible to reporters.
   */
  internalNote?: string

  /**
   * Optional public note, potentially visible to the reporter.
   */
  publicNote?: string

  /**
   * Extensible JSON payload for loose activity-specific metadata (e.g. assignmentId).
   */
  meta?: l.LexMap

  /**
   * True if this activity was created by an automated process (e.g. queue router) rather than a direct human action.
   */
  isAutomated: boolean

  /**
   * DID of the actor who created this activity, or the service DID for automated activities.
   */
  createdBy: l.DidString

  /**
   * Full member record of the moderator who created this activity
   */
  moderator?: TeamDefs.Member

  /**
   * Full view of the report this activity belongs to.
   */
  report?: ReportView

  /**
   * When this activity was created
   */
  createdAt: l.DatetimeString
}

export type { ReportActivityView }

/** A single activity entry on a report. */
const reportActivityView = /*#__PURE__*/ l.typedObject<ReportActivityView>(
  $nsid,
  'reportActivityView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    reportId: /*#__PURE__*/ l.integer(),
    activity: /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<QueueActivity>((() => queueActivity) as any),
        /*#__PURE__*/ l.typedRef<AssignmentActivity>(
          (() => assignmentActivity) as any,
        ),
        /*#__PURE__*/ l.typedRef<EscalationActivity>(
          (() => escalationActivity) as any,
        ),
        /*#__PURE__*/ l.typedRef<CloseActivity>((() => closeActivity) as any),
        /*#__PURE__*/ l.typedRef<ReopenActivity>((() => reopenActivity) as any),
        /*#__PURE__*/ l.typedRef<NoteActivity>((() => noteActivity) as any),
      ],
      false,
    ),
    internalNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    publicNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    meta: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
    isAutomated: /*#__PURE__*/ l.boolean(),
    createdBy: /*#__PURE__*/ l.string({ format: 'did' }),
    moderator: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
    ),
    report: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ReportView>((() => reportView) as any),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { reportActivityView }

/** Live statistics for reports for the current calendar day, filterable by queue, moderator, or report type. */
type LiveStats = {
  $type?: 'tools.ozone.report.defs#liveStats'

  /**
   * Number of reports currently not closed.
   */
  pendingCount?: number

  /**
   * Number of reports closed today.
   */
  actionedCount?: number

  /**
   * Number of reports escalated today.
   */
  escalatedCount?: number

  /**
   * Reports received today.
   */
  inboundCount?: number

  /**
   * Percentage of reports actioned (actionedCount / inboundCount * 100), rounded to nearest integer.
   */
  actionRate?: number

  /**
   * Average time in seconds from report creation (or moderator assignment) to close.
   */
  avgHandlingTimeSec?: number

  /**
   * When these statistics were last computed.
   */
  lastUpdated?: l.DatetimeString
}

export type { LiveStats }

/** Live statistics for reports for the current calendar day, filterable by queue, moderator, or report type. */
const liveStats = /*#__PURE__*/ l.typedObject<LiveStats>(
  $nsid,
  'liveStats',
  /*#__PURE__*/ l.object({
    pendingCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalatedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    inboundCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionRate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    avgHandlingTimeSec: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    lastUpdated: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { liveStats }

/** A single daily snapshot of report statistics for a calendar date. */
type HistoricalStats = {
  $type?: 'tools.ozone.report.defs#historicalStats'

  /**
   * The calendar date this snapshot covers (YYYY-MM-DD).
   */
  date: string

  /**
   * When this snapshot was last computed.
   */
  computedAt?: l.DatetimeString

  /**
   * Number of reports not closed at time of computation.
   */
  pendingCount?: number

  /**
   * Number of reports closed during this day.
   */
  actionedCount?: number

  /**
   * Number of reports escalated during this day.
   */
  escalatedCount?: number

  /**
   * Reports received during this day.
   */
  inboundCount?: number

  /**
   * Percentage of reports actioned (actionedCount / inboundCount * 100), rounded to nearest integer.
   */
  actionRate?: number

  /**
   * Average time in seconds from report creation (or moderator assignment) to close.
   */
  avgHandlingTimeSec?: number
}

export type { HistoricalStats }

/** A single daily snapshot of report statistics for a calendar date. */
const historicalStats = /*#__PURE__*/ l.typedObject<HistoricalStats>(
  $nsid,
  'historicalStats',
  /*#__PURE__*/ l.object({
    date: /*#__PURE__*/ l.string(),
    computedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    pendingCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    escalatedCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    inboundCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    actionRate: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    avgHandlingTimeSec: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  }),
)

export { historicalStats }

type AssignmentView = {
  $type?: 'tools.ozone.report.defs#assignmentView'
  id: number
  did: l.DidString

  /**
   * The moderator assigned to this report
   */
  moderator?: TeamDefs.Member
  queue?: QueueDefs.QueueView
  reportId: number
  startAt: l.DatetimeString
  endAt?: l.DatetimeString
}

export type { AssignmentView }

const assignmentView = /*#__PURE__*/ l.typedObject<AssignmentView>(
  $nsid,
  'assignmentView',
  /*#__PURE__*/ l.object({
    id: /*#__PURE__*/ l.integer(),
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    moderator: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<TeamDefs.Member>((() => TeamDefs.member) as any),
    ),
    queue: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<QueueDefs.QueueView>(
        (() => QueueDefs.queueView) as any,
      ),
    ),
    reportId: /*#__PURE__*/ l.integer(),
    startAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    endAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
  }),
)

export { assignmentView }
